import React from 'react';

import './styles.css';

export default function Who() {
    return (
        <div className="content content-who">
            <div className="who-left">
                <h2>Quem somos?</h2>
                <article>
                    Fundado no ano de 2007, nosso escritório têm se destacado nas mais variadas áreas de atuação do Direito, prezando sempre pela excelência e ética no desenvolvimento dos trabalhos.<br></br>

                    Nossa missão é a defesa dos interesses de nossos clientes, priorizando um atendimento personalizado e com a máxima confiabilidade.<br></br>

                    Isto só é possível pelo constante aprimoramento profissional de toda nossa equipe, bem como pelo comprometimento que temos com o Direito e a Justiça!
                    <br></br>

                </article>
            </div>


            <div className="who-img">
                <img src={require('../../../../assets/img/advogado.jpeg')} alt="advogado" />
            </div>
        </div>
    )
}